import type { SchemaBuilderConditionFieldValueProps } from "./schema-builder-condition-field-value.type";

import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";

export const SchemaBuilderConditionFieldValue = ({
  field,
  isRequired,
}: SchemaBuilderConditionFieldValueProps) => {
  const { t } = useTranslation();

  const placeholder = t("schema:conditions.value.placeholder");
  const missingMessage = t("schema:conditions.value.missing");

  return (
    <Form.Item
      name={[field.name, "value"]}
      rules={[{ required: isRequired, message: missingMessage }]}
      className="schema-builder-condition-field-value"
    >
      <Input
        disabled={!isRequired}
        placeholder={placeholder}
        aria-label={placeholder}
      />
    </Form.Item>
  );
};
